<template>
  <el-tabs v-model="card_index">
    <el-tab-pane label="总览" name="ThirdPartyLitigationCompanyProject">
      <ThirdPartyLitigationCompanyProject v-if="card_index==='ThirdPartyLitigationCompanyProject'" :urge_type="4" />
    </el-tab-pane>
    <el-tab-pane label="结算列表" name="ThirdPartyCompanyProjectMonth">
      <ThirdPartyCompanyProjectMonth v-if="card_index==='ThirdPartyCompanyProjectMonth'" :urge_type="4" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import ThirdPartyLitigationCompanyProject from "./ThirdPartyLitigationCompanyProject";
import ThirdPartyCompanyProjectMonth from "../thirdparty/ThirdPartyCompanyProjectMonth";
export default {
  name: "ThirdPartyLitigationCompanyProjectLayout",
  components: {ThirdPartyCompanyProjectMonth, ThirdPartyLitigationCompanyProject},
  data(){
    return{
      card_index:"ThirdPartyLitigationCompanyProject"
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty_litigation/ThirdPartyLitigationCompanyProjectLayout.vue